<div class="expired">
    <p>{{'promo.expired' | translate}}</p>
</div>